import { ExternalTokenizer, LRParser } from '@lezer/lr';
import { LRLanguage, indentNodeProp, delimitedIndent, foldNodeProp, foldInside, LanguageSupport } from '@codemirror/language';
import { styleTags, tags } from '@lezer/highlight';

// This file was generated by lezer-generator. You probably shouldn't edit it.
const backtickQuotedString = 30;

const backTick = '`'.charCodeAt(0);
const atSign = '@'.charCodeAt(0);
const backtickString = new ExternalTokenizer((input, stack) => {
    if (!stack.canShift(backtickQuotedString)) {
        return;
    }
    if (input.next === atSign) {
        input.advance();
    }
    let backticks = 0;
    for (; input.next === backTick; input.advance()) {
        backticks++;
    }
    if (backticks === 0) {
        return;
    }
    let currentRun = 0;
    while (currentRun < backticks && input.next !== -1) {
        if (input.next === backTick) {
            currentRun++;
        }
        else {
            currentRun = 0;
        }
        input.advance();
    }
    input.acceptToken(backtickQuotedString);
}, { contextual: true, fallback: true });

// This file was generated by lezer-generator. You probably shouldn't edit it.
const spec_identifier = {__proto__:null,true:72, false:72, nil:74, import:76, "import*":76, use:76, let:76, do:76, upscope:76, quote:76, quasiquote:76, unquote:76, splice:76, with:76, "with-dyns":76, "with-syms":76, "with-vars":76, default:76, set:76, setdyn:76, var:76, "var-":76, varfn:76, varglobal:76, def:76, "def-":76, defdyn:76, defglobal:76, defn:76, "defn-":76, fn:76, "short-fn":76, defmacro:76, "defmacro-":76, if:76, "if-not":76, "if-let":76, "if-with":76, when:76, "when-let":76, "when-with":76, unless:76, cond:76, case:76, match:76, while:76, for:76, forv:76, break:76, loop:76, seq:76, tabseq:76, generate:76, each:76, eachk:76, eachp:76, coro:76, yield:76, try:76, label:76, return:76, macex:76, macex1:76};
const parser = LRParser.deserialize({
  version: 14,
  states: "%QQYQROOOOQP'#C_'#C_OOQP'#C`'#C`OOQP'#Ca'#CaOOQP'#Cb'#CbOOQP'#Cc'#CcOOQP'#Cd'#CdO!dQRO'#CmO!kQRO'#CpO!rQRO'#CsO!yQRO'#CuO#QQRO'#CwOOQP'#C}'#C}OOQP'#Cx'#CxQYQROOOOQP,59X,59XO#XQRO,59XOOQP,59[,59[O#`QRO,59[OOQP,59_,59_O#gQRO,59_OOQP,59a,59aO#nQRO,59aOOQP,59c,59cO#uQRO,59cOOQP-E6v-E6vOOQP1G.s1G.sOOQP1G.v1G.vOOQP1G.y1G.yOOQP1G.{1G.{OOQP1G.}1G.}",
  stateData: "$S~OpOSPOS~OX[OY[OZ[O[[O][O^[O`VOcWOfXOhYOjZOnUOrPOsQOtROuSOvTOwUO~O__O~PYObaO~PYOecO~PYObeO~PYOegO~PYO_jO~PYObkO~PYOelO~PYObmO~PYOenO~PYOwshjr~",
  goto: "!{rPPPssssssPPPPPPPPsPPsPPsPsPs!RPPPP!mi[OVWXYZ^`bdfhQ^OQ`VQbWQdXQfYQhZ]i^`bdfhi]OVWXYZ^`bdfh",
  nodeNames: "⚠ LineComment Program Identifier Number Boolean Nil Special String Pipe Comma Semicolon Quote Quasiquote Keyword ) ( Form ] [ Tuple } { Struct @[ Array @{ Table",
  maxTerm: 39,
  nodeProps: [
    ["openedBy", 15,"(",18,"[ @[",21,"{ @{"],
    ["closedBy", 16,")",-2,19,24,"]",-2,22,26,"}"]
  ],
  skippedNodes: [0,1],
  repeatNodeCount: 1,
  tokenData: ">l~RuXY#fYZ#f]^#fpq#fqr#wrs%Xst&utu#wvw#wwx'^xy'cyz'hz{#w{|'m|}7v}!O'm!O!P)Q!P!Q#w!Q!R7{!R![8}![!]:r!]!^<S!^!_#w!_!`#w!`!a#w!a!b#w!b!c<X!c!}#w!}#O=|#P#Q>R#Q#R#w#R#S#w#T#o#w#o#p>W#p#q>]#q#r>b#r#s>g~#kSp~XY#fYZ#f]^#fpq#f~#|cr~qr#wtu#wvw#wz{#w{|#w}!O#w!O!P#w!P!Q#w!Q![#w![!]#w!^!_#w!_!`#w!`!a#w!a!b#w!b!c#w!c!}#w#Q#R#w#R#S#w#T#o#w~%[VOr%Xrs%qs#O%X#O#P%v#P;'S%X;'S;=`&o<%lO%X~%vOw~~%yRO;'S%X;'S;=`&S;=`O%X~&VWOr%Xrs%qs#O%X#O#P%v#P;'S%X;'S;=`&o;=`<%l%X<%lO%X~&rP;=`<%l%X~&zSP~OY&uZ;'S&u;'S;=`'W<%lO&u~'ZP;=`<%l&u~'cO[~~'hO`~~'mO_~~'rdr~qr#wtu#wvw#wz{#w{|#w}!O#w!O!P)Q!P!Q#w!Q!R.n!R![0^![!]#w!^!_#w!_!`#w!`!a#w!a!b#w!b!c#w!c!}#w#Q#R#w#R#S#w#T#o#w~)Vcr~qr#wtu#wvw#wz{#w{|#w}!O#w!O!P#w!P!Q#w!Q![*b![!]#w!^!_#w!_!`#w!`!a#w!a!b#w!b!c#w!c!}#w#Q#R#w#R#S#w#T#o#w~*ies~r~qr#wtu#wvw#wz{#w{|#w}!O#w!O!P#w!P!Q#w!Q![*b![!]#w!^!_#w!_!`#w!`!a#w!a!b#w!b!c#w!c!}#w#Q#R#w#R#S*b#T#X#w#X#Y+z#Y#o#w~,Pcr~qr#wtu#wvw#wz{#w{|#w}!O#w!O!P#w!P!Q#w!Q![-[![!]#w!^!_#w!_!`#w!`!a#w!a!b#w!b!c#w!c!}#w#Q#R#w#R#S#w#T#o#w~-ccs~r~qr#wtu#wvw#wz{#w{|#w}!O#w!O!P#w!P!Q#w!Q![-[![!]#w!^!_#w!_!`#w!`!a#w!a!b#w!b!c#w!c!}#w#Q#R#w#R#S#w#T#o#w~.ugs~r~qr#wtu#wvw#wz{#w{|#w}!O#w!O!P*b!P!Q#w!Q![0^![!]#w!^!_#w!_!`#w!`!a#w!a!b#w!b!c#w!c!}#w#Q#R#w#R#S0^#T#X#w#X#Y+z#Y#l#w#l#m1v#m#o#w~0ees~r~qr#wtu#wvw#wz{#w{|#w}!O#w!O!P*b!P!Q#w!Q![0^![!]#w!^!_#w!_!`#w!`!a#w!a!b#w!b!c#w!c!}#w#Q#R#w#R#S0^#T#X#w#X#Y+z#Y#o#w~1{er~qr#wtu#wvw#wz{#w{|#w}!O#w!O!P3^!P!Q#w!Q![6^![!]#w!^!_#w!_!`#w!`!a#w!a!b#w!b!c#w!c!i6^!i!}#w#Q#R#w#R#S#w#T#Z6^#Z#o#w~3cer~qr#wtu#wvw#wz{#w{|#w}!O#w!O!P#w!P!Q#w!Q![4t![!]#w!^!_#w!_!`#w!`!a#w!a!b#w!b!c#w!c!i4t!i!}#w#Q#R#w#R#S#w#T#Z4t#Z#o#w~4{es~r~qr#wtu#wvw#wz{#w{|#w}!O#w!O!P#w!P!Q#w!Q![4t![!]#w!^!_#w!_!`#w!`!a#w!a!b#w!b!c#w!c!i4t!i!}#w#Q#R#w#R#S4t#T#Z4t#Z#o#w~6ees~r~qr#wtu#wvw#wz{#w{|#w}!O#w!O!P4t!P!Q#w!Q![6^![!]#w!^!_#w!_!`#w!`!a#w!a!b#w!b!c#w!c!i6^!i!}#w#Q#R#w#R#S6^#T#Z6^#Z#o#w~7{OY~~8QTs~!O!P8a!Q![8}#R#S8}#X#Y8o#l#m9`~8fRs~!Q![8a#R#S8a#X#Y8o~8rP!Q![8u~8zPs~!Q![8u~9SSs~!O!P8a!Q![8}#R#S8}#X#Y8o~9cS!O!P9o!Q![:^!c!i:^#T#Z:^~9rR!Q![9{!c!i9{#T#Z9{~:QSs~!Q![9{!c!i9{#R#S9{#T#Z9{~:cTs~!O!P9{!Q![:^!c!i:^#R#S:^#T#Z:^~:wc^~qr:rtu:rvw:rz{:r{|:r}!O:r!O!P:r!P!Q:r!Q![:r![!]:r!^!_:r!_!`:r!`!a:r!a!b:r!b!c:r!c!}:r#Q#R:r#R#S:r#T#o:r~<XOZ~~<^fr~qr#wrs%Xtu#wvw#wz{#w{|#w}!O#w!O!P#w!P!Q#w!Q![#w![!]#w!^!_#w!_!`#w!`!a#w!a!b#w!b!c#w!c!}#w!}#O=r#Q#R#w#R#S#w#T#o#w#o#p=w~=wOh~~=|Oj~~>ROc~~>WOb~~>]Of~~>bOX~~>gOe~~>lO]~",
  tokenizers: [backtickString, 0],
  topRules: {"Program":[0,2]},
  specialized: [{term: 34, get: value => spec_identifier[value] || -1}],
  tokenPrec: 136
});

const JanetLanguage = LRLanguage.define({
    parser: parser.configure({
        props: [
            indentNodeProp.add({
                Form: delimitedIndent({ closing: ")", align: false }),
                Tuple: delimitedIndent({ closing: "]", align: false }),
                Array: delimitedIndent({ closing: "]", align: false }),
                Struct: delimitedIndent({ closing: "}", align: false }),
                Table: delimitedIndent({ closing: "}", align: false }),
            }),
            foldNodeProp.add({
                Form: foldInside,
                Tuple: foldInside,
                Array: foldInside,
                Struct: foldInside,
                Table: foldInside,
            }),
            styleTags({
                Identifier: tags.name,
                Boolean: tags.bool,
                Number: tags.number,
                String: tags.string,
                LineComment: tags.lineComment,
                Nil: tags.null,
                Keyword: tags.atom,
                "( )": tags.paren,
                "@[ [ ]": tags.squareBracket,
                "@{ { }": tags.brace,
                "Pipe Comma Semicolon Quote Quasiquote": tags.punctuation,
                Special: tags.keyword,
            })
        ]
    }),
    languageData: {
        commentTokens: { line: "#" },
        closeBrackets: {
            brackets: ['(', '[', '{', '"', '`']
        },
    }
});
function janet() {
    return new LanguageSupport(JanetLanguage);
}

export { JanetLanguage, janet };
